import {create} from 'zustand';
import {persist} from 'zustand/middleware';
import {UseSelectedPlanStoreType} from './types';

export const useSelectedPlanStore = create(
	persist<UseSelectedPlanStoreType>(
		set => ({
			selectedPlan: undefined,
			setSelectedPlan: plan => set({selectedPlan: plan}),
			resetSelectedPlan: () => set({selectedPlan: undefined}),
		}),
		{
			name: 'selectedPlan',
		},
	),
);
